import { Route, Routes } from 'react-router-dom'

import ActivityLogs from './screens/ActivityLog'

const ActivityLogsRoutes = () => (
  <Routes>
    <Route path="/" element={<ActivityLogs />} />
  </Routes>
)

export default ActivityLogsRoutes
